import { render } from "./IconField.vue?vue&type=template&id=00410559"
import script from "./IconField.vue?vue&type=script&lang=js"
export * from "./IconField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__